// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xwMOt","col":"styles_col__ZBBg8"};